export const ITEM_CATALOG = {
  dorans_blade: {
    id: 'dorans_blade',
    name: "Espada de Doran",
    cost: 450,
    stats: { ad: 8, maxHp: 80 },
    icon: '🗡️',
    description: '+8 AD, +80 Vida Máxima',
    components: []
  },
  long_sword: {
    id: 'long_sword',
    name: "Espada Larga",
    cost: 350,
    stats: { ad: 10 },
    icon: '⚔️',
    description: '+10 Daño de Ataque (AD)',
    components: []
  },
  dagger: {
    id: 'dagger',
    name: "Daga",
    cost: 300,
    stats: { as: 0.12 },
    icon: '🗡️',
    description: '+12% Velocidad de Ataque (AS)',
    components: []
  },
  boots_of_speed: {
    id: 'boots_of_speed',
    name: "Botas de Velocidad",
    cost: 300,
    stats: { ms: 25 },
    icon: '🥾',
    description: '+25 Velocidad de Movimiento (MS)',
    components: []
  },
  noonquiver: {
    id: 'noonquiver',
    name: "Carcaj del Mediodía",
    cost: 1300,
    stats: { ad: 30, as: 0.15 },
    icon: '🏹',
    description: '+30 AD, +15% AS (Receta: 2x Espada Larga + Daga)',
    components: ['long_sword', 'long_sword', 'dagger']
  },
  kraken_slayer: {
    id: 'kraken_slayer',
    name: "Matakrakens",
    cost: 3000,
    stats: { ad: 50, as: 0.40 },
    isMythic: true,
    icon: '🦑',
    description: '+50 AD, +40% AS (Receta: Carcaj del Mediodía + 2x Daga)',
    components: ['noonquiver', 'dagger', 'dagger']
  },
  health_potion: {
    id: 'health_potion',
    name: "Poción de Vida",
    cost: 40,
    stats: {},
    isConsumable: true,
    maxStacks: 5,
    healAmount: 150,
    icon: '🧪',
    description: 'Restaura 150 HP durante 15 segundos (stack hasta 5)',
    components: []
  },
  cloak_of_agility: {
    id: 'cloak_of_agility',
    name: "Capa de Agilidad",
    cost: 600,
    stats: { critChance: 0.15 },
    icon: '💫',
    description: '+15% Probabilidad de Golpe Crítico',
    components: []
  },
  pickaxe: {
    id: 'pickaxe',
    name: "Pico",
    cost: 875,
    stats: { ad: 25 },
    icon: '⛏️',
    description: '+25 Daño de Ataque (AD)',
    components: []
  },
  infinity_edge: {
    id: 'infinity_edge',
    name: "Hoja del Infinito",
    cost: 3100,
    stats: { ad: 70, critChance: 0.20 },
    icon: '⚔️',
    description: '+70 AD, +20% Crítico — Los críticos infligen 230% de daño (Receta: Pico + 2x Capa de Agilidad)',
    components: ['pickaxe', 'cloak_of_agility', 'cloak_of_agility']
  },
  galeforce: {
    id: 'galeforce',
    name: "Fuerza de Tempestad",
    cost: 3400,
    stats: { ad: 55, as: 0.20, critChance: 0.20 },
    icon: '🌪️',
    description: '+55 AD, +20% AS, +20% Crítico — Activo: dash 450u (CD 60s)',
    components: ['long_sword', 'dagger', 'cloak_of_agility'],
    isMythic: true,
    hasActive: true,
    activeDashRange: 450,
    activeCooldownMs: 60000
  },
  immortal_shieldbow: {
    id: 'immortal_shieldbow',
    name: 'Arcoescudo Inmortal',
    cost: 3400,
    stats: { ad: 50, as: 0.20, critChance: 0.20, maxHp: 250 },
    icon: '🏹',
    description: '+50 AD, +20% AS, +20% Crítico, +250 Vida (Mythic ADC)',
    components: ['noonquiver', 'cloak_of_agility'],
    isMythic: true
  },
  liandrys_anguish: {
    id: 'liandrys_anguish',
    name: 'Angustia de Liandry',
    cost: 3200,
    stats: { ap: 80, maxHp: 300 },
    icon: '🔥',
    description: '+80 AP, +300 Vida — Mythic mage burn (ARAM)',
    components: ['amplifying_tome', 'amplifying_tome'],
    isMythic: true
  },
  everfrost: {
    id: 'everfrost',
    name: 'Everfrost',
    cost: 3400,
    stats: { ap: 70, maxHp: 250 },
    icon: '❄️',
    description: '+70 AP, +250 Vida — Mythic mage root burst (ARAM)',
    components: ['amplifying_tome', 'amplifying_tome'],
    isMythic: true
  },
  cloth_armor: {
    id: 'cloth_armor',
    name: 'Armadura de Tela',
    cost: 280,
    stats: { armor: 15 },
    icon: '🛡️',
    description: '+15 Armadura',
    components: []
  },
  amplifying_tome: {
    id: 'amplifying_tome',
    name: 'Tomo Amplificador',
    cost: 420,
    stats: { ap: 20 },
    icon: '📘',
    description: '+20 Poder de habilidad',
    components: []
  },
  control_ward: {
    id: 'control_ward',
    name: 'Centinela de Control',
    cost: 75,
    stats: {},
    isUtility: true,
    isWard: true,
    icon: '👁️',
    description: 'Visión verdadera en un área (utilidad ARAM)',
    components: []
  }
};
